import send from './send';
import { eventsKeys } from '../constants';

export default ({ questionId }) => {
  send(eventsKeys.QUICK_SIGNUP_STARTED, {
    questionId,
  });
};
